import { useMemo } from "react";
import { useDropzone } from "react-dropzone";
import FileDisplay from "../../../components/FileDisplay";
import { getDocumentTypeFromMimeType } from "../../../components/forms/selects/DocumentTypesSelect";
import { FormLabel } from "../../../components/forms";

const HubwiseFilePicker = ({ label, value, setValue }) => {

    const onDrop = (files) => setValue(files[0]);

    const onClear = () => setValue(null);

    const { getRootProps, getInputProps } = useDropzone({
        accept: { "text/csv": [] },
        onDrop
    });

    const docType = useMemo(() => value == null
        ? null
        : getDocumentTypeFromMimeType(value.type),
        [value]
    );

    return <>
        <div className="d-flex flex-column">
            <FormLabel>{label}</FormLabel>
            {!value && <div {...getRootProps({ className: 'dropzone d-flex mb-2 border border-3 border-opacity-10 has-pointer' })}>
                <input {...getInputProps()} />
                <div className="d-flex flex-fill justify-content-center align-items-center py-3 px-2">
                    <p className="m-0">Drag and drop files here or click to browse.</p>
                </div>
            </div>}
            {value && <div className="row">
                <div className="col">
                    <FileDisplay
                        file={value}
                        onClearFile={onClear}
                        fileDataIcon={docType?.icon ?? 'file'}
                    />
                </div>
            </div>}
        </div>
    </>
}

export default HubwiseFilePicker;